// extracted by mini-css-extract-plugin
export var numpadContainer = "_lx-1";
export var phoneButton = "_lx-0";